<script setup lang="ts">
import { AppText } from '@shared/ui/typography'

defineOptions({
  name: 'TaskAdditionalDetailsPlaceholder',
})
</script>

<template>
  <div class="task-additional-details-placeholder">
    <AppText
      name="body1"
      color="slate-500"
    >
      Select task type to fill additional details
    </AppText>
  </div>
</template>

<style lang="scss" scoped src="./TaskAdditionalDetailsPlaceholder.scss" />